import {
  ADD_CASE_TO_SUBSCRIPTION_FAIL,
  ADD_CASE_TO_SUBSCRIPTION_REQUEST,
  ADD_CASE_TO_SUBSCRIPTION_SUCCESS,
  CANCEL_SUBSCRIPTION_FAIL,
  CANCEL_SUBSCRIPTION_REQUEST,
  CANCEL_SUBSCRIPTION_SUCCESS,
  CREATE_BILLING_SUBSCRIPTION_FAIL,
  CREATE_BILLING_SUBSCRIPTION_REQUEST,
  CREATE_BILLING_SUBSCRIPTION_SUCCESS,
  GET_BILLING_SUBSCRIPTION_FAIL,
  GET_BILLING_SUBSCRIPTION_REQUEST,
  GET_BILLING_SUBSCRIPTION_SUCCESS,
  REMOVE_CASE_TO_SUBSCRIPTION_FAIL,
  REMOVE_CASE_TO_SUBSCRIPTION_REQUEST,
  REMOVE_CASE_TO_SUBSCRIPTION_SUCCESS,
  RESET_ADD_CASE_TO_SUBSCRIPTION,
  RESET_BILLING_SUBSCRIPTION,
  RESET_CANCEL_SUBSCRIPTION,
  RESET_CREATE_BILLING_SUBSCRIPTION,
  RESET_REMOVE_CASE_TO_SUBSCRIPTION,
  RESET_UPDATE_BILLING_SUBSCRIPTION,
  UPDATE_BILLING_SUBSCRIPTION_FAIL,
  UPDATE_BILLING_SUBSCRIPTION_REQUEST,
  UPDATE_BILLING_SUBSCRIPTION_SUCCESS,
} from "../../assets/constants/billingSubscription";

// GET BILLING SUBSCRIPTION REDUCER
export const getBillingSubscriptionReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_BILLING_SUBSCRIPTION_REQUEST:
      return { loading: true };
    case GET_BILLING_SUBSCRIPTION_SUCCESS:
      return { loading: false, billingSubscription: action.payload };
    case GET_BILLING_SUBSCRIPTION_FAIL:
      return { loading: false, error: action.payload };
    case RESET_BILLING_SUBSCRIPTION:
      return {};
    default:
      return state;
  }
};

// CREATE BILLING SUBSCRIPTION REDUCER
export const createBillingSubscriptionReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_BILLING_SUBSCRIPTION_REQUEST:
      return { loading: true };
    case CREATE_BILLING_SUBSCRIPTION_SUCCESS:
      return { loading: false, createdBillingSubscription: action.payload };
    case CREATE_BILLING_SUBSCRIPTION_FAIL:
      return { loading: false, error: action.payload };
    case RESET_CREATE_BILLING_SUBSCRIPTION:
      return {};
    default:
      return state;
  }
};

// UPDATE BILLING SUBSCRIPTION REDUCER
export const updateBillingSubscriptionReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_BILLING_SUBSCRIPTION_REQUEST:
      return { loading: true };
    case UPDATE_BILLING_SUBSCRIPTION_SUCCESS:
      return { loading: false, updatedBillingSubscription: action.payload };
    case UPDATE_BILLING_SUBSCRIPTION_FAIL:
      return { loading: false, error: action.payload };
    case RESET_UPDATE_BILLING_SUBSCRIPTION:
      return {};
    default:
      return state;
  }
};

// ADD CASE TO SUBSCRIPTION REDUCER
export const addCaseToSubscriptionReducer = (state = {}, action) => {
  switch (action.type) {
    case ADD_CASE_TO_SUBSCRIPTION_REQUEST:
      return { loading: true };
    case ADD_CASE_TO_SUBSCRIPTION_SUCCESS:
      return { loading: false, caseAddedToSubscription: action.payload };
    case ADD_CASE_TO_SUBSCRIPTION_FAIL:
      return { loading: false, error: action.payload };
    case RESET_ADD_CASE_TO_SUBSCRIPTION:
      return {};
    default:
      return state;
  }
};

// REMOVE CASE TO SUBSCRIPTION REDUCER
export const removeCaseFromSubscriptionReducer = (state = {}, action) => {
  switch (action.type) {
    case REMOVE_CASE_TO_SUBSCRIPTION_REQUEST:
      return { loading: true };
    case REMOVE_CASE_TO_SUBSCRIPTION_SUCCESS:
      return { loading: false, caseRemovedFromSubscription: action.payload };
    case REMOVE_CASE_TO_SUBSCRIPTION_FAIL:
      return { loading: false, error: action.payload };
    case RESET_REMOVE_CASE_TO_SUBSCRIPTION:
      return {};
    default:
      return state;
  }
};

// CANCEL BILLING SUBSCRIPTION REDUCER
export const cancelBillingSubscriptionReducer = (state = {}, action) => {
  switch (action.type) {
    case CANCEL_SUBSCRIPTION_REQUEST:
      return { loading: true };
    case CANCEL_SUBSCRIPTION_SUCCESS:
      return { loading: false, cancelledSubscription: action.payload };
    case CANCEL_SUBSCRIPTION_FAIL:
      return { loading: false, error: action.payload };
    case RESET_CANCEL_SUBSCRIPTION:
      return {};
    default:
      return state;
  }
};
